import { render } from "./Settings.vue?vue&type=template&id=42dd87fa&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=42dd87fa&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/pins/pinsv2/Pins_Queuing_System/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dd87fa"]])

export default __exports__